

class SearchView {
  _parentElement = document.querySelector('.search');
  _searchInput = document.querySelector(".search-input");
  _toggleBox = document.querySelector(".search-results")
  _searchLabel = document.querySelector(".search-label")
  _searchLabel = document.querySelector(".search-label")
  _timer;
  /**
   * 
   * @returns the value of input search
   */
  getQuery() {
    const query = this._searchInput.value;
    return query;
  }

  _clearInput() {
    this._searchInput.value = ""
  }

  openSearchResults() {
    this._toggleBox.classList.add("open")
  }

  closeSearchResults() {
    this._toggleBox.classList.remove("open");
  }

  clear() {
    this.closeSearchResults();
    this._clearInput();
  }

  /**
   * 
   * @param {Function} handler handler is a function that will be call for event listener for input focus to expand the search results box
   */

  addFocusSearch(handler) {
    document.querySelector('.search-wrapper').addEventListener('click', function (e) {
      handler()
    });
  }

  /**
   * 
   * @param {Function} handler handler is a function that will be call for event listener for input blur to collapse the search results box
   */
  addBlurSearch(handler) {
    document.querySelector('body').addEventListener('click', function (e) {
      e.stopPropagation();
      const button = e.target.closest(".button");
      const input = e.target.closest(".search-input")
      if (input || button) return;
      handler()
    });
  }
  _handleChangeSearch(handler) {
    this._debounce(handler, 300)
  }
  /**
   * 
   * @param {Function} handler handler is a function that will be call for event listener  
   */
  addHandlerSearch(handler) {
    this._searchInput.addEventListener('input', this._handleChangeSearch.bind(this, handler));

    this._parentElement.addEventListener("submit", e => {
      e.preventDefault();
      if (this.getQuery()?.trim() === "") {
        var span = document.createElement('span');
        span.classList.add("error-msg");
        span.innerHTML = "You need to enter a search term before pressing submit";
        const errorWrapper = document.querySelector(".error-msg");
        if (errorWrapper) return
        this._searchLabel.appendChild(span);
        setTimeout(() => {
          span.remove();
        }, 2000)
      }
      handler();
    })
  }

  _debounce = function (fn, d) {
    if (this._timer) {
      clearTimeout(this._timer);
    }
    this._timer = setTimeout(fn, d);
  }
}

export default new SearchView();